<template>
  <div class="w98">
   <div class="crumb">
      <span><router-link to="/Help">帮助</router-link>  > </span>
      <span>运行环境</span>
    </div>
     <help-Menu></help-Menu>
    <div class="rightContent">
       <div class="runMessage">
        <p class="text">系统运行所需的硬件配置:</p>
        <p>内存：8G</p>
        <p>CPU：3.0GHz</p>
        <p>硬盘：500G</p>
        <p>分辨率：1280*1024以上</p>
        <p  class="text">软件环境：</p>
        <p>a）服务端：</p>
        <p>操作系统：Centos 2.6.32-431.el6.x86_64；WindowServer 2008；</p>
        <p>Web服务器：Tomcat 7.0</p>
        <p>数据库：Oracle 11.2.0.4.  64bit Production </p>
        <p>b) 应用终端：</p>
        <p>PC 端操作系统为Window7及以上 、Mac；</p>
        <p  class="text">网络条件：</p>
        <p>网络架构：B/S架构。</p>
        <p>网络类型：广域网。</p>
        <p>互联网下载速度不低于500k/s。</p>
       </div>
    </div>
</div>
</template>

<script type="text/ecmascript-6">
  import {getRightHeight} from '@/common/js/rightHeight'
  import helpHead from '@/components/common/header/helpHead'
  import helpMenu from '@/components/common/helpMenu/helpMenu'
  export default {
    data () {
      return {
         height:''
      }
    },
    components:{
        helpHead,
        helpMenu
    },
      mounted() {
      setTimeout(() => {
//        this._getRightW()
        getRightHeight('rightContent', this.height)
      }, 20)
      window.addEventListener('resize', () => {
//        this._getRightW()
        getRightHeight('rightContent', this.height)
      })
    },
}

</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
.content
    min-width: 100vw
    height: 100vh
    overflow: hidden
    .rightContent
      position: relative
      float: right
      height :calc(100vh - 80px)
      width: calc(80% - 1px)
      min-width: 919px
      background :#fff
  .crumb
    line-height: 30px
    margin: 5px 0 0 20px
.runMessage
  padding:50px
  color:#555
  line-height:25px
  .text
    font-size 14px
    color:#000
    font-weight:bolder
</style>



// WEBPACK FOOTER //
// RunEnvironment.vue?fa8fa4c2